var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "orgRegistration", attrs: { id: "org-registration-app" } },
    [
      _c(
        "div",
        { staticClass: "registrationContainer" },
        [
          _c("progress-tracker", { attrs: { steps: _vm.steps } }),
          _vm._v(" "),
          _c("img", {
            staticClass: "logo",
            attrs: {
              src: _vm.darkMode
                ? _vm.brandingService.getLoginDarkLogoUrl()
                : _vm.brandingService.getLoginLogoUrl(),
              alt: "brandingService.getLoginLogoAlt()",
            },
          }),
          _vm._v(" "),
          !_vm.submitted && !_vm.termsStep
            ? _c(
                "section",
                { staticClass: "middle form" },
                [
                  _c("h1", [_vm._v("My Info")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "panels" }, [
                    _c(
                      "div",
                      { staticClass: "leftPanel" },
                      [
                        _c("h3", [_vm._v("User Name & Password")]),
                        _vm._v(" "),
                        _c("v-text-field", {
                          staticClass: "email",
                          attrs: {
                            solo: "",
                            flat: "",
                            disabled: "",
                            outlined: "",
                            dense: "",
                          },
                          model: {
                            value: _vm.email,
                            callback: function ($$v) {
                              _vm.email = $$v
                            },
                            expression: "email",
                          },
                        }),
                        _vm._v(" "),
                        _c("PasswordEntry", {
                          staticClass: "v-adjust",
                          on: { "password-updated": _vm.updatePassword },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rightPanel" },
                      [
                        _c("h3", [_vm._v("Company Info")]),
                        _vm._v(" "),
                        _c("v-text-field", {
                          staticClass: "companyName",
                          attrs: {
                            solo: "",
                            flat: "",
                            outlined: "",
                            dense: "",
                            label: "Company Name",
                          },
                          model: {
                            value: _vm.companyName,
                            callback: function ($$v) {
                              _vm.companyName = $$v
                            },
                            expression: "companyName",
                          },
                        }),
                        _vm._v(" "),
                        _c("v-autocomplete", {
                          staticClass: "timeZone",
                          attrs: {
                            solo: "",
                            flat: "",
                            outlined: "",
                            dense: "",
                            autofocus: false,
                            autocomplete: "off",
                            items: _vm.timeZoneItems,
                            label: "Time Zone",
                          },
                          on: { input: _vm.timeZoneChanged },
                          model: {
                            value: _vm.timeZone,
                            callback: function ($$v) {
                              _vm.timeZone = $$v
                            },
                            expression: "timeZone",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "submit",
                      attrs: {
                        color: "#4D52E5",
                        block: "",
                        depressed: "",
                        disabled: _vm.validateFields(),
                      },
                      on: { click: _vm.nextStep },
                    },
                    [_vm._v("Next")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.submitted && _vm.termsStep
            ? _c("section", { staticClass: "middle terms" }, [
                !_vm.managing
                  ? _c("section", { staticClass: "defaultBody" }, [
                      _c("h3", [_vm._v("Optional Privacy Consents")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "documents" }, [
                        _vm._v(
                          "Agree to HP collecting and using your personal data to provide, develop, and improve the quality of our service, security, products, applications and operations, to deliver products and drive continuous improvements."
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "consentButton btn btn-primary",
                          on: {
                            click: function ($event) {
                              return _vm.submitEmail(true)
                            },
                          },
                        },
                        [_vm._v("Accept All")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "consentButton btn btn-default",
                          on: { click: _vm.manage },
                        },
                        [_vm._v("Manage Options")]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.managing
                  ? _c(
                      "section",
                      { staticClass: "manageBody" },
                      [
                        _c("h3", [_vm._v("Optional Privacy Consents")]),
                        _vm._v(" "),
                        _c("v-checkbox", {
                          staticClass: "communications",
                          attrs: {
                            label:
                              "Agree to HP collecting and using your personal data to provide, develop, and improve the quality of our service, security, products, applications and operations, to deliver products and drive continuous improvements.",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.orgDataConsent,
                            callback: function ($$v) {
                              _vm.orgDataConsent = $$v
                            },
                            expression: "orgDataConsent",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "consentButton btn btn-primary",
                            on: {
                              click: function ($event) {
                                return _vm.submitEmail(false)
                              },
                            },
                          },
                          [_vm._v("Save")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "consentButton btn btn-default",
                            on: { click: _vm.manage },
                          },
                          [_vm._v("Cancel")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.submitted
            ? _c("section", { staticClass: "middle submitted" }, [
                !_vm.submitError
                  ? _c("section", { staticClass: "submittedSuccess" }, [
                      _c("h1", [_vm._v("Finished")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _vm._v(
                          "You're ready to start using WXP Collaboration."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _c("a", { attrs: { href: "/" } }, [_vm._v("Log in")]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.submitError
                  ? _c("section", { staticClass: "submittedError" }, [
                      _c("h1", [_vm._v("Something Went Wrong")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _vm._v("There was an error processing your request."),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _vm._v("Please contact "),
                        _c(
                          "a",
                          { attrs: { href: _vm.getSupportContactUrl() } },
                          [_vm._v("support")]
                        ),
                        _vm._v(" for further assistance with this issue."),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "copywrite" }, [
            _vm._v("© " + _vm._s(_vm.currentYear) + " HP Inc. "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.hp.com/us-en/privacy/privacy-central.html",
                  target: "_blank",
                },
              },
              [_vm._v("Privacy Statement")]
            ),
            _vm._v(",\n      "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://support.hp.com/us-en/document/ish_12775809-12775790-16",
                  target: "_blank",
                },
              },
              [_vm._v("EULA")]
            ),
            _vm._v(",\n      and "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf",
                  target: "_blank",
                },
              },
              [_vm._v("DPA")]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }